import * as React from "react";

export const ChevronDownIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22.4286 11.9833C22.717 12.2717 22.7392 12.7255 22.4951 13.0393L22.4286 13.1147L16.2061 19.3372L9.98351 13.1147C9.67109 12.8022 9.67109 12.2957 9.98351 11.9833C10.2719 11.6949 10.7257 11.6727 11.0395 11.9167L11.1149 11.9833L16.2067 17.0738L21.2972 11.9833C21.5856 11.6949 22.0394 11.6727 22.3532 11.9167L22.4286 11.9833Z"
            fill="#333333" />
    </svg>
);
